export const enClientPortalInternalApprovalModal = {
    actions: {},
    visibilityConsequence: 'Make all comments on this draft visible to the appraiser',
    itemLabel: 'Issue approval on behalf of the fund',
    confirmationLabel: 'I confirm that I approve this draft.',
}
